import { colors } from '../constants';

const unselectedStrokeColor = '#bebebe';
const unselectedFillColor = colors.lighterGrey;
const unselectedStrokeStrongYesOrNoColor = '#d7d7d';

const defaultArrowProps = {
  width: 20,
  strokeWidth: 1,
  color: colors.darkGrey,
};

export {
  defaultArrowProps,
  unselectedFillColor,
  unselectedStrokeColor,
  unselectedStrokeStrongYesOrNoColor,
};
